import * as React from "react"
import { Grid } from "@mui/material"

import PageWrapper from "Pages/@PageWrapper"
import { STOCK_ROUTES } from "@constants"
import { isSystemBusy } from "@signals"
import { TourProvider, TourTarget } from "@tour"
import StockChangesFilters from "./Filters"
import StockChangesPriceStockEvolutionChart from "./PriceEvolutionChart"
import StockChangesReportFormDrawer from "./ReportForm"
import StockChangesTable from "./Table"


export default function StockChangesPage() {

    return <PageWrapper
        actions={null}
        tourPageKey="changes"
        head={`DIP Insight | ${STOCK_ROUTES.STOCK_CHANGES_TITLE}`}
        title={STOCK_ROUTES.STOCK_CHANGES_TITLE}
        subtitle={STOCK_ROUTES.STOCK_CHANGES_SUBTITLE}
        filters={<StockChangesFilters />}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={4} sx={{ mt: 1 }}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="changes-table" height={350} />
                <StockChangesTable />
            </Grid>

            <Grid item xs={12}>
                <StockChangesPriceStockEvolutionChart />
            </Grid>

            <Grid item xs={12}>
                <StockChangesReportFormDrawer />
            </Grid>
        </Grid>
    </PageWrapper>
}
